import { BaseApiOutput, BaseApiInput } from './base-api.model';
import { InvoiceListItem } from '../invoice-list-item.model';
export class OrderListApiOutput extends BaseApiOutput {
    invoicelist: InvoiceListItem[];
}

export class OrderListApiInput extends BaseApiInput {
    name = 'orderlist';
}
